






































































import Vue from "vue";
import moment from "moment";
import Web3 from "web3";
import { setIntervalAsync, clearIntervalAsync, SetIntervalAsyncTimer } from "set-interval-async/fixed";
import { AbiItem } from "web3-utils";
import pinkSalePresaleContractABI from "../../assets/PinkSalePresaleContractABI.json";
import bep20ContractABI from "../../assets/BEP20ContractABI.json";

export default Vue.extend({
  name: "DisableWhitelistMonitor",

  data: () => ({
    dialog: false as boolean,
    isStarted: false as boolean,
    btnColor: "primary" as string,
    btnText: "Start" as string,
    presaleAddress: "" as string,
    error: "" as string,
    tokenAddress: " " as string,
    tokenAddressLink: "" as string,
    tokenName: " " as string,
    tokenOwner: " " as string,
    tokenOwnerAddressLink: "" as string,
    foundTime: " " as string,
    transactionHash: " " as string,
    transactionHashLink: "" as string,
    interval: undefined as undefined | SetIntervalAsyncTimer,
    isProcessing: false,
  }),
  methods: {
    async click(): Promise<void> {
      if (this.isStarted) {
        if (this.interval != undefined) {
          await clearIntervalAsync(this.interval);
        }
        this.error = "";
        this.tokenAddress = " ";
        this.tokenAddressLink = "";
        this.tokenName = " ";
        this.tokenOwner = " ";
        this.tokenOwnerAddressLink = "";
        this.transactionHash = " ";
        this.transactionHashLink = "";
        this.btnColor = "primary";
        this.btnText = "Start";
        this.isStarted = false;
        return;
      }

      this.error = "";
      this.tokenAddress = " ";
      this.tokenAddressLink = "";
      this.tokenName = " ";
      this.tokenOwner = " ";
      this.tokenAddressLink = "";
      this.foundTime = " ";
      this.transactionHash = " ";
      this.transactionHashLink = "";

      const web3 = new Web3(new Web3.providers.HttpProvider("https://bsc-dataseed1.defibit.io:443"));
      web3.extend({
        property: "txpool",
        methods: [
          {
            name: "content",
            call: "txpool_content",
          },
        ],
      });

      try {
        const presaleContractAbi = pinkSalePresaleContractABI as any as AbiItem;
        const presaleContract = new web3.eth.Contract(presaleContractAbi, Web3.utils.toChecksumAddress(this.presaleAddress));

        // token 情報の設定
        const results = await Promise.all([presaleContract.methods.token().call(), presaleContract.methods.owner().call()]);
        this.tokenAddress = Web3.utils.toChecksumAddress(results[0]);
        this.tokenAddressLink = `https://bscscan.com/address/${this.tokenAddress}`;
        this.tokenOwner = Web3.utils.toChecksumAddress(results[1]);
        this.tokenOwnerAddressLink = `https://bscscan.com/address/${this.tokenOwner}`;
        const tokenContractAbi = bep20ContractABI as any as AbiItem;
        const tokenContract = new web3.eth.Contract(tokenContractAbi, this.tokenAddress);
        this.tokenName = await tokenContract.methods.name().call();
      } catch (error) {
        this.error = "Address is not PresaleAddress";
        return;
      }

      this.isStarted = true;
      this.btnColor = "secondary";
      this.btnText = "Stop";

      // transaction の監視を開始
      const checkedTransactionHashs: string[] = [];
      this.interval = setIntervalAsync(async () => {
        const result = await (web3 as any).txpool.content();
        const pendingTransactions: any[] = Object.values(result.pending);
        outerLoop: for (const pendingTransaction of pendingTransactions) {
          const transactions: any[] = Object.values(pendingTransaction);
          for (const transaction of transactions) {
            if (checkedTransactionHashs.length > 20000) {
              const deleteCount = checkedTransactionHashs.length - 15000;
              checkedTransactionHashs.splice(0, deleteCount);
            }

            if (transaction == null || checkedTransactionHashs.includes(transaction.hash)) {
              continue;
            }

            if (transaction.to.toLowerCase() != this.presaleAddress.toLowerCase()) {
              checkedTransactionHashs.push(transaction.hash);
              continue;
            }

            const methodSignature = transaction.input.slice(0, 10);
            if (methodSignature != "0x5feb14d3") {
              checkedTransactionHashs.push(transaction.hash);
              continue;
            }

            const last = transaction.input.slice(-1);
            if (last != "0") {
              checkedTransactionHashs.push(transaction.hash);
              continue;
            }

            this.transactionHash = transaction.hash;
            this.transactionHashLink = `https://bscscan.com/tx/${this.transactionHash}`;

            this.btnColor = "primary";
            this.btnText = "Start";
            this.isStarted = false;

            this.dialog = true;

            if (this.interval != undefined) {
              await clearIntervalAsync(this.interval);
            }

            break outerLoop;
          }
        }
      }, 10);
    },
  },
  watch: {
    presaleAddress: async function (value: string) {
      if (value == null) {
        if (this.interval != undefined) {
          await clearIntervalAsync(this.interval);
        }
        this.btnColor = "primary";
        this.btnText = "Start";
        this.isStarted = false;
        this.dialog = false;
        this.error = "";
        this.tokenAddress = " ";
        this.tokenAddressLink = "";
        this.tokenName = " ";
        this.tokenOwnerAddressLink = "";
        this.tokenOwner = " ";
        this.foundTime = " ";
        this.transactionHash = " ";
        this.transactionHashLink = "";
      }
    },
  },
});
